import ControlTowerAssociatedItem from 'core/entities/ControlTowerEntities/ControlTowerAssociatedItemObject';

class ControlTowerItem {
    constructor (data) {
        if (data) {
            this.id = data.id;
            this.url = data.url;
            this.date = data.date;
            this.retrievedData = {
                status: data.retrieved_data.status,
                price: data.retrieved_data.price,
                originalPrice: data.retrieved_data.original_price,
                stock: data.retrieved_data.stock,
                availability: data.retrieved_data.availability,
                imgUrl: data.retrieved_data.img_url,
                marketplaceOffers: data.retrieved_data.marketplace_offers ? data.retrieved_data.marketplace_offers : [],
                additionalData: data.retrieved_data.additional_data ? data.retrieved_data.additional_data : {}
            };
            this.associatedItems = data.associated_items.map(item => new ControlTowerAssociatedItem(item));
            this.logs = data.logs;
            this.redirection = data.redirection ? data.redirection:null;
        }
    }
}

export default ControlTowerItem;
